module.exports = __webpack_public_path__ + "fonts/TTNormsPro-ThinItalic.181a4622.woff2";